import { CustomIconUrl } from "@p0security/integrations-custom-shared/registry";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { BundleAccesses } from "./accesses.ts";

const BundleFilters = {
  bundle: { keys: ["description", "id", "label"] },
} as const satisfies AnyFilterSchema;
export type BundleFilters = typeof BundleFilters;

export const BundleRegistration = Registration({
  accesses: BundleAccesses,
  category: "resource",
  components: undefined,
  docs: {},
  filters: BundleFilters,
  label: "Access Bundle",
  logoUrl: CustomIconUrl,
  maturity: "preview",
  requestType: "requestable",
  useMapping: [],
});

registerIntegration("bundle", BundleRegistration);
